import React, { useEffect } from 'react'
import {
  Title,
  SpacingVertical,
  Tabbed,
  Flex,
  Button,
  BUTTON_VARIANT_SECONDARY,
  BUTTON_VARIANT_PRIMARY
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import RecipientsSelectionGroupsTab from './RecipientsSelectionGroupsTab'
import RecipientsSelectionAllTab from './RecipientsSelectionAllTab'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { pageState, wizardEnableStep1State } from '../recoil/states/page'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import styled from '@emotion/styled'
import { checkRecipientsCallback } from '../recoil/callbacks/callbacks'

const StyledTabbed = styled(Tabbed)`
  > div {
    padding: 24px 32px 0px 32px !important;
  }
`

const WizardStep1 = () => {
  const intl = useIntl()
  const history = useHistory()
  const setPageState = useSetRecoilState(pageState)
  const wizardEnableStep1 = useRecoilValue(wizardEnableStep1State)
  const { recipients } = useRecoilValue(pageState)
  const checkRecipients = useRecoilCallback(checkRecipientsCallback, [])

  const onChangeTab = tab => {
    setPageState(prev => ({
      ...prev,
      recipients: tab
    }))
  }

  const handleBack = () => {
    history.push('/messages/rcs/list')
  }

  const handleContinue = () => {
    checkRecipients()
  }

  return (
    <>
      <Title variant='M'>
        {intl.formatMessage({ id: 'Load.Rcs.RecipientsSelectionTitle' })}
      </Title>
      <SpacingVertical />
      <StyledTabbed
        defaultActive={recipients}
        onChange={onChangeTab}
        tabs={[
          {
            content: <RecipientsSelectionGroupsTab />,
            id: 'filter',
            label: intl.formatMessage({
              id: 'Load.Rcs.RecipientsSelectionGroupsTab'
            })
          },
          {
            content: <RecipientsSelectionAllTab />,
            id: 'all',
            label: intl.formatMessage({
              id: intl.formatMessage({
                id: 'Load.Rcs.RecipientsSelectionAllTab'
              })
            })
          }
        ]}
      />
      <Flex justifyContent='space-between' margin='8px 0 0 0'>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handleBack}
          data-mu-test='button-back-step-1'
        >
          {intl.formatMessage({
            id: 'Load.Rcs.RecipientsSelectionBack'
          })}
        </Button>
        <span>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            onClick={handleContinue}
            disabled={!wizardEnableStep1}
            data-mu-test='button-RecipientsQueue'
          >
            {intl.formatMessage({
              id: 'Load.Rcs.RecipientsQueue'
            })}
          </Button>
        </span>
      </Flex>
    </>
  )
}

export default WizardStep1
